import { CclInfoTableRowTemplate } from "../../../components/common/cclInfoTable/cclInfoTable";
import { eInfoTableValueFieldEditType } from "../../../components/common/cclInfoTable/cclInfoTableValueField";

export type MiscWorkEntry = {
    id: number;
    workDate: string;
    description: string;
    hours: number;
    rate: number;
    amount: number;
};

export type MiscWorkNote = {
    id: number;
    created: string;
    createdBy: string;
    note: string;
};

export type MiscWorkRecord = {
    id: number;
    projectCode: string;
    projectName: string;
    trainerName: string;
    trainerEmail: string;
    workType: string;
    status: string;
    managingLocation: string;
    client: string;
    lineOfBusiness: string;
    glGroup: string;
    glCode: string;
    workDate: string;
    submittedDate: string;
    approvedBy: string;
    totalHours: number;
    totalAmount: number;
    entries: MiscWorkEntry[];
    notes: MiscWorkNote[];
};

const buildInfoRow = (id: string, label: string, fieldType = "string"): CclInfoTableRowTemplate => ({
    id,
    fieldType,
    editable: false,
    label,
    required: false,
    value: "",
    actionField: null,
    valueField: {
        value: "",
        editFieldType: eInfoTableValueFieldEditType.Text,
        url: null,
        hoverText: null,
        checked: null,
        id: "",
        selectOptions: null,
    },
});

export const miscWorkRecords: MiscWorkRecord[] = [
    {
        id: 1001,
        projectCode: "MW-1001",
        projectName: "Executive Coaching Prep",
        trainerName: "Avery Mitchell",
        trainerEmail: "avery.mitchell@example.com",
        workType: "Coaching Preparation",
        status: "Submitted",
        managingLocation: "Greensboro",
        client: "Northwind Leadership",
        lineOfBusiness: "Coaching",
        glGroup: "COACH",
        glCode: "6010",
        workDate: "2026-09-08T00:00:00",
        submittedDate: "2026-09-10T00:00:00",
        approvedBy: "Morgan Lee",
        totalHours: 6.5,
        totalAmount: 975,
        entries: [
            { id: 1, workDate: "2026-09-08T00:00:00", description: "Participant profile review", hours: 2.5, rate: 150, amount: 375 },
            { id: 2, workDate: "2026-09-09T00:00:00", description: "Coaching guide preparation", hours: 4, rate: 150, amount: 600 },
        ],
        notes: [
            { id: 1, created: "2026-09-10T09:15:00", createdBy: "Morgan Lee", note: "Ready for payroll review after project code confirmation." },
        ],
    },
    {
        id: 1002,
        projectCode: "MW-1002",
        projectName: "Assessment Debrief Support",
        trainerName: "Jordan Patel",
        trainerEmail: "jordan.patel@example.com",
        workType: "Assessment Support",
        status: "Approved",
        managingLocation: "Colorado Springs",
        client: "Contoso Finance",
        lineOfBusiness: "Assessment",
        glGroup: "ASSESS",
        glCode: "6045",
        workDate: "2026-09-12T00:00:00",
        submittedDate: "2026-09-13T00:00:00",
        approvedBy: "Taylor Brooks",
        totalHours: 3,
        totalAmount: 420,
        entries: [
            { id: 1, workDate: "2026-09-12T00:00:00", description: "Debrief material customization", hours: 1.5, rate: 140, amount: 210 },
            { id: 2, workDate: "2026-09-12T00:00:00", description: "Client follow-up summary", hours: 1.5, rate: 140, amount: 210 },
        ],
        notes: [
            { id: 1, created: "2026-09-13T14:40:00", createdBy: "Taylor Brooks", note: "Approved for the September 30 pay cycle." },
        ],
    },
    {
        id: 1003,
        projectCode: "MW-1003",
        projectName: "Custom Design Consultation",
        trainerName: "Sam Rivera",
        trainerEmail: "sam.rivera@example.com",
        workType: "Design Consultation",
        status: "Draft",
        managingLocation: "San Diego",
        client: "Fabrikam Health",
        lineOfBusiness: "Custom",
        glGroup: "CUSTOM",
        glCode: "6070",
        workDate: "2026-09-15T00:00:00",
        submittedDate: "",
        approvedBy: "",
        totalHours: 4,
        totalAmount: 680,
        entries: [
            { id: 1, workDate: "2026-09-15T00:00:00", description: "Discovery call and design notes", hours: 4, rate: 170, amount: 680 },
        ],
        notes: [
            { id: 1, created: "2026-09-15T16:05:00", createdBy: "Sam Rivera", note: "Awaiting final client scope before submission." },
        ],
    },
];

export const getMiscWorkRecordById = (id: string | number): MiscWorkRecord | undefined =>
    miscWorkRecords.find((record) => record.id.toString() === id.toString());

export const createMiscWorkSummaryTemplate = (): CclInfoTableRowTemplate[] => [
    buildInfoRow("projectCode", "Project ID"),
    buildInfoRow("projectName", "Project Name"),
    buildInfoRow("workType", "Work Type"),
    buildInfoRow("status", "Status"),
    buildInfoRow("client", "Client"),
    buildInfoRow("lineOfBusiness", "Line of Business"),
    buildInfoRow("managingLocation", "Managing Location"),
    buildInfoRow("workDate", "Work Date", "Date"),
    buildInfoRow("submittedDate", "Submitted Date", "Date"),
    buildInfoRow("approvedBy", "Approved By"),
];

export const createMiscWorkTrainerTemplate = (): CclInfoTableRowTemplate[] => [
    buildInfoRow("trainerName", "Trainer"),
    buildInfoRow("trainerEmail", "Email"),
    buildInfoRow("glGroup", "GL Group"),
    buildInfoRow("glCode", "GL Code"),
    buildInfoRow("totalHours", "Total Hours"),
    buildInfoRow("totalAmount", "Total Amount"),
];